import { Create, useForm } from "@refinedev/antd";
import { Authenticated, useNavigation, useTranslate } from "@refinedev/core";
import { Form, Input } from "antd";
import { useOrganization } from "hooks/useOrganization";
import { AssetLibrary } from "pages/media/types";
import useIsAdmin from "hooks/useIsAdmin";

const CreateAssetLibraryPage = ({ isPublic }: { isPublic?: boolean }) => {
  const t = useTranslate();
  const { organization } = useOrganization({});
  const isAdmin = useIsAdmin();
  const { edit } = useNavigation();
  const [form] = Form.useForm();

  const resource =
    isPublic && isAdmin
      ? "media/asset_libraries"
      : `media/${organization?.id}/asset_libraries`;

  const { onFinish } = useForm<AssetLibrary>({
    action: "create",
    resource,
    redirect: false,
  });

  async function handleFinish() {
    const result = await onFinish(form.getFieldsValue());
    if (result) {
      edit("media_asset_libraries", result?.data.id);
    }
  }
  return (
    <Authenticated key="CreateAssetLibraryPage">
      <Create saveButtonProps={{ onClick: handleFinish }}>
        <Form form={form}>
          <Form.Item name="name" label={t("asset_libraries.name")}>
            <Input />
          </Form.Item>
        </Form>
      </Create>
    </Authenticated>
  );
};

export default CreateAssetLibraryPage;
